export default __webpack_public_path__ + "static/media/insta14.9e678d43.webp";